module.exports = __webpack_public_path__ + "img/carlos-bruce.b15b45a5.png";